import React from "react";
import Input from "blocks/Input";
import NO_AVA_BIG from "styles/img/no-ava-big.png";
import { PROVIDER_LOGO_CONTENT_TYPES, TARGET_FILE_MAX_SIZE } from "./constants";
import { observer, inject } from "mobx-react";
import HttpClient from "services/HttpClient";
import TextAreaWrapper from "blocks/TextAreaWrapper";

const CRETE_REGULAR = "/api/v1/workshops/";

@inject("onlineWorkshop")
@observer
export default class WorkShopContactInformation extends React.Component {
  state = {};
  handleChange = e => {
    this.props.onlineWorkshop.handleChange(e);
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.handleSubmit();
  };

  handleDublicate = e => {
    e.preventDefault();
    this.props.handleDublicate();
  };

  handleLogoChange = e => {
    if (e.target.files && e.target.files[0]) {
      let file = e.target.files[0];
      if (
        file.size > TARGET_FILE_MAX_SIZE ||
        !PROVIDER_LOGO_CONTENT_TYPES.includes(file.type)
      ) {
        let newState = _.assign({}, this.state, { file_errors: true });
        this.setState(newState);
        return;
      }
      let reader = new FileReader();
      reader.onload = e => {
        this.props.onlineWorkshop.handleChange({
          provider_logo: e.target.result
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  addErrorToBio = () => {
    this.props.onlineWorkshop.addErrorToBio();
  };

  removePhoto = () => {
    if (this.props.onlineWorkshop.workshop.provider_logo_url) {
      new HttpClient()
        .put(CRETE_REGULAR + this.props.onlineWorkshop.workshop.id, {
          provider_logo: null
        })
        .then(() => {
          this.props.onlineWorkshop.removeLogo();
        });
    } else {
      this.props.onlineWorkshop.removeLogo();
    }
  };

  render() {
    return (
      <div className="col-12 col-md-3 push-md-9">
        <form className="workshop-creator-sidebar" onSubmit={this.handleSubmit}>
          <div className="workshop-creator-sidebar-user">
            <div className="workshop-creator-sidebar-user-avatar-holder">
              <div className="workshop-creator-sidebar-user-avatar">
                {this.props.onlineWorkshop.showRemoveLogo() && (
                  <span
                    className="icon ic-close-ico remove-photo"
                    onClick={this.removePhoto}
                  />
                )}
                {this.props.onlineWorkshop.getWorkShop().provider_logo ? (
                  <img
                    src={this.props.onlineWorkshop.getWorkShop().provider_logo}
                    alt="avatar"
                  />
                ) : this.props.onlineWorkshop.workshop.provider_logo_url ? (
                  <img
                    src={this.props.onlineWorkshop.workshop.provider_logo_url}
                    alt="avatar"
                  />
                ) : (
                  <img src={NO_AVA_BIG} alt="avatar" className="no-ava" />
                )}
              </div>
              <label htmlFor="provider_logo">
                <input
                  type="file"
                  id="provider_logo"
                  onChange={this.handleLogoChange}
                  style={{ display: "none" }}
                />
                <span className="add-photo">ADD PHOTO</span>
                <span style={{
                  color: 'rgba(0, 0, 0, 0.54)',
                  fontSize: '10px',
                  marginLeft: '10px',
                }}>max size 2MB</span>
              </label>
            </div>

            <div className="workshop-creator-sidebar-user-name sidebar-holder">
              <Input
                name="provided_by"
                type="text"
                value={this.props.onlineWorkshop.getWorkShop().provided_by}
                handleChange={this.handleChange}
                placeholder="Provided by"
                error={this.props.onlineWorkshop.getErrors().provided_by}
              />
            </div>
          </div>

          <TextAreaWrapper
            name="provider_bio"
            type="text"
            value={this.props.onlineWorkshop.getWorkShop().provider_bio}
            handleChange={this.handleChange}
            addErrorToBio={this.addErrorToBio}
            placeholder="Provider Bio"
            error={this.props.onlineWorkshop.getErrors().provider_bio}
          />
          <div className="workshop-creator-sidebar-additional " />

          <div className="workshop-creator-sidebar-additional ">
            <Input
              name="host"
              type="text"
              value={this.props.onlineWorkshop.getWorkShop().host}
              handleChange={this.handleChange}
              placeholder="Host (Optional)"
              error={this.props.onlineWorkshop.getErrors().host}
            />

            <Input
              name="contact_name"
              type="text"
              value={this.props.onlineWorkshop.getWorkShop().contact_name}
              handleChange={this.handleChange}
              placeholder="Contact Name (Optional)"
              error={this.props.onlineWorkshop.getErrors().contact_name}
            />

            <Input
              name="contact_email"
              type="text"
              value={this.props.onlineWorkshop.getWorkShop().contact_email}
              handleChange={this.handleChange}
              placeholder="Contact Email (Optional)"
              error={this.props.onlineWorkshop.getErrors().contact_email}
            />

            <Input
              name="contact_phone"
              type="text"
              value={this.props.onlineWorkshop.getWorkShop().contact_phone}
              handleChange={this.handleChange}
              placeholder="Contact Phone Number (Optional)"
              error={this.props.onlineWorkshop.getErrors().contact_phone}
            />

            <Input
              name="website"
              type="text"
              value={this.props.onlineWorkshop.getWorkShop().website}
              handleChange={this.handleChange}
              placeholder="Website (Optional)"
              error={this.props.onlineWorkshop.getErrors().website}
            />
          </div>

          <div className="workshop-creator-sidebar-publish">
            <span onClick={this.handleSubmit} className="btn prime bordered">
              {this.props.onlineWorkshop.workshop.id
                ? "UPDATE WORKSHOP"
                : "SUBMIT WORKSHOP INFO FOR APPROVAL"}
            </span>
          </div>
          {!!this.props.onlineWorkshop.workshop.id && (
            <div className="workshop-creator-sidebar-publish">
              <span onClick={this.handleDublicate} className="btn prime bordered">
                Duplicate
              </span>
            </div>
          )}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_workshop/WorkShopContactInformation.jsx